import { Box, Checkbox, FormControl, FormControlLabel, Grid } from '@mui/material';
import {
  OptionFieldProps,
  withGridItemCSS,
  withWrapperCSS,
} from 'components/organisms/forms/form-builder/types';
import { noop } from 'lodash';
import React, { FC, useEffect, useState } from 'react';

export const MultipleCheckboxField: FC<
  OptionFieldProps<string[]> & withGridItemCSS & withWrapperCSS
> = ({
  disabled = false,
  initValue = [],
  onChange = noop,
  label = '',
  options,
  required = false,
  wrapperCss,
  xs = 12,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>(initValue);
  useEffect(() => setSelectedOptions(initValue), [initValue]);

  const handleCheckboxChange =
    (optionName: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const newSelectedOptions = event.target.checked
        ? [...selectedOptions, optionName]
        : selectedOptions.filter((name) => name !== optionName);
      setSelectedOptions(newSelectedOptions);

      if (onChange) {
        onChange(newSelectedOptions, `schedule`);
      }
    };

  return (
    <Grid item xs={xs} style={{ margin: 'auto' }}>
      <FormControl required={required} style={{ width: '100%', ...wrapperCss }}>
        <Box style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          {label && (
            <label>
              {label} {required ? '*' : null}
            </label>
          )}
          {options.map(({ name, description }, index) => (
            <FormControlLabel
              key={`checkbox_${index}`}
              control={
                <Checkbox
                  checked={selectedOptions.includes(name.toString())}
                  onChange={handleCheckboxChange(name.toString())}
                  disabled={disabled}
                />
              }
              label={description}
            />
          ))}
        </Box>
      </FormControl>
    </Grid>
  );
};
